<article *ngIf="data">
    <div class="container">
        <div class="row">
            <div class="image-wrapper">
                <ng-container *ngIf="data.image && data.image.src">
                    <app-image
                        [image]="data.image"
                        [width]="1568"
                        [index]="data.spotIndex"
                        [height]="520"
                        [style]="{ objectFit: 'cover', height: '100%' }"
                        [intersectionOptions]="{ threshold: 0 }"
                        crop="crop"
                    ></app-image>
                </ng-container>
            </div>
            <div
                class="col-12 col-md-8 col-lg-5 col-xl-4"
                [ngClass]="{ 'offset-md-4 offset-lg-7 offset-xl-8': data.alignment === alignment.Right }"
            >
                <div appParallaxElement [travel]="40" [dullness]="10">
                    <div class="content-wrapper">
                        <div class="content" [ngClass]="{ white: data.textColor === textColor.White }">
                            <div class="headline">
                                <app-spot-headline *ngIf="data.headlineText" [index]="data.spotIndex" section="h2">
                                    {{ data.headlineText }}
                                </app-spot-headline>
                            </div>

                            <div
                                *ngIf="data.paragraph"
                                class="kk-rte text-space-bottom"
                                appInterceptLinks
                                [innerHTML]="data.paragraph | safe: 'html'"
                            ></div>

                            <div class="same-day-delivery">
                                <app-same-day-delivery layout="normal" place="hero"></app-same-day-delivery>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</article>

<div class="container" appParallaxElement [travel]="40" [dullness]="10" *ngIf="data.showUsps">
    <app-usp></app-usp>
</div>
